module.exports = __webpack_public_path__ + "img/caiwuzhuangkuang.ea863511.svg";